import { FC } from 'react';
import { Section } from './ui/Section';
import { EntryBlock } from './ui/EntryBlock';
import type { Entry } from '../types/cv';

interface Props {
  publications: Entry[];
  title?: string;
  oneLine?: boolean;
}

export const Publications: FC<Props> = ({
  publications,
  title = 'Publications',
  oneLine = false,
}) => (
  <Section title={title}>
    {publications.map((pub, i) => (
      <EntryBlock
        key={`${pub.name}-${i}`}
        entry={pub}
        title={pub.name}
        role={pub.publisher && <span className="cv-sub">{pub.publisher}</span>}
        note={pub.summary}
        oneLine={oneLine}
      />
    ))}
  </Section>
);

export default Publications;
